import { useCallback } from 'react'
import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useAuth } from './UseAuth'

/**
 * Hook for sending events to Intercom
 *
 * // just event name
 * trackIntercomEvent('onboarding_completed')
 *
 * // event with metadata info
 * trackIntercomEvent('integration_connected', { platform: 'facebook' })
 */
export const useIntercomEvent = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const currentWorkspace = useCurrentWorkspace()
  const auth = useAuth()

  const trackIntercomEvent = useCallback(
    (eventName: string, customMetadata?: Record<string, any>) => {
      if (typeof window.Intercom !== 'function') {
        return
      }

      const metadata = {
        workspace_id: currentWorkspaceId,
        workspace_name: currentWorkspace?.name,
        is_ap_freemium: currentWorkspace?.is_ap_freemium || false,
        is_virtual_marketer: currentWorkspace?.is_virtual_marketer || false,
        user_id: auth?.id,
        email: auth?.email,
        ...customMetadata,
      }

      window.Intercom('trackEvent', eventName, metadata)
    },
    [currentWorkspaceId, currentWorkspace, auth],
  )

  return trackIntercomEvent
}
